<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "delete-role-modal",
    },

    // The role ID possibly being deleted
    roleId: {
      type: String,
      required: true,
    },
  },

  computed: {
    // The role to delete
    role() {
      return this.roles[this.roleId];
    },

    // Mapped vuex state
    ...mapState(["roles"]),
  },

  methods: {
    // Delete the role, hide the modal, and go to the roles page
    async doDelete() {
      let success = await this.deleteRole({ roleId: this.roleId });
      if (success) {
        this.hide();
        this.$router.push("/team/roles");
      }
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["deleteRole"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Confirm Delete"
    button-size="sm"
    hide-header-close
  >
    <p v-if="role">
      Are you sure you want to delete the
      <b>{{ role.name }}</b>
      role?
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="danger" @click="doDelete">Delete</b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
